import {BUTTON_VARIANT, Button} from '@time-webkit/all/atoms/button';
import {ChevronUpIcon} from '@time-webkit/all/icons/chevron-up';
import classNames from 'classnames';
import React, {type ComponentProps} from 'react';

import styles from './styles.module.css';

type Props = {
    children?: React.ReactNode;
    isOpen: boolean;
} & ComponentProps<typeof Button>;

export const DropdownButton = ({children, isOpen, className, ...buttonProps}: Props) => {
    return (
        <Button
            variant={isOpen ? BUTTON_VARIANT.SECONDARY : BUTTON_VARIANT.LINK}
            className={classNames(styles.more__button, className)}
            {...buttonProps}
        >
            {children}
            <ChevronUpIcon
                width={16}
                height={16}
                className={classNames(styles.arrow, isOpen ? styles.arrow__up : styles.arrow__down)}
            />
        </Button>
    );
};
